module.exports = __webpack_public_path__ + "img/rosa-bandet-iconi.aad51bb9.png";